module.exports = __webpack_public_path__ + "static/media/29EUNOG5.a6ee0826.jpg";